"use client";

// Last-resort error screen (a crash in the root layout). Reports to Sentry only
// when a DSN is configured; the SDK is loaded on demand, not bundled up front.

import { useEffect } from "react";

export default function GlobalError({ error }: { error: Error & { digest?: string } }) {
  useEffect(() => {
    // Public DSN, inlined at build. Sentry itself was initialised (or not) by
    // instrumentation-client.ts; this only forwards the crash when it's on.
    if (!process.env.NEXT_PUBLIC_SENTRY_DSN) return;
    import("@sentry/nextjs")
      .then((Sentry) => Sentry.captureException(error))
      .catch(() => {});
  }, [error]);

  return (
    <html lang="en">
      <body style={{ fontFamily: "system-ui, sans-serif", padding: 24 }}>
        <p>Something went wrong. Reload the page to try again.</p>
      </body>
    </html>
  );
}
